import { invoiceServices } from "@/services/invoice.service";

import { InvoiceRecurringDashboardParams } from "@/models/interface/invoice-recurring-dashboard/InvoiceRecurringDashboardParams.interface";
import { InvoiceRecurringDashboardResponseDto } from "@/models/interface/invoice-recurring-dashboard/InvoiceRecurringDashboardResponseDto.interface";
import { LabelInValue } from "@/types";
import { Moment } from "moment";

export type FilterField = Partial<{
  customer: LabelInValue | null;
  date: Array<Moment> | null;
}>;

const useInvoiceRecurringDashboard = () => {
  const findAll = (
    params?: InvoiceRecurringDashboardParams
  ): Promise<InvoiceRecurringDashboardResponseDto> => {
    return invoiceServices.getInvoiceRecurringDashboard(params);
  };

  const findByIcId = (
    icId: string,
    params?: InvoiceRecurringDashboardParams
  ) => {
    return invoiceServices.getInvoiceRecurringDashboardDetail(icId, params);
  };

  return { findAll, findByIcId };
};

export default useInvoiceRecurringDashboard;
